// Wip Department 

import { useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const getWipDepartment = async (body) => {
    const { data } = await apiClient.post(
      "/api/v9/myBinnys/wipDepartment",
      body
    );
    return data?.data;
  };


  export const useWipDepartment = (params) => {
    return useQuery({
      queryKey: ["wipDepartment", params],
      queryFn: () => getWipDepartment(params),
      enabled: !!params?.clientCode,
      staleTime: 1000 * 60 * 5,
    });
  };



  // Wip Designs

  const getWipDepartmentDesign = async (params) => {
    const { data } = await apiClient.post(
      "/api/v9/myBinnys/wipDepartmentDesign",
      params
    );
    return data?.data;
  };


  export const useWipDepartmentDesign = (params) => {
    return useQuery({
      queryKey: ["wipDepartmentDesign", params.page, params.searchBy, params.sortBy, params.departmentCode],
      queryFn: () => getWipDepartmentDesign(params),
    //   keepPreviousData: true, 
      staleTime: 1000 * 60 * 5,
      enabled: !!params?.clientCode && !!params?.departmentCode,
    });
  };



  // Wip Single Designs View Message / Info

  export const fetchWipDepartmentDesignInfo = async (bagNo) => {
    const res = await apiClient.get(
      `/api/v9/myBinnys/wipDepartmentDesignInfo?bagNo=${bagNo}`
    );
    return res.data?.data; 
  };


